import SearchIcon from '@mui/icons-material/Search';
import { useAppSelector } from 'app/hooks';
import BoxWrapper from 'blocks/BoxWrapper';
import Card from 'blocks/Card';
import Col from 'blocks/Col';
import Row, { RowItem } from 'blocks/Row';
import { Text, Title } from 'blocks/Text';
import Loading from 'components/Loading';
import Paths from 'helper/paths';
import { useForm } from 'hooks/useForm';
import WithSidebar from 'layouts/WithSidebar';
import { useEffect } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getDashboardService } from 'services/dashboard.service';
import {
  dashboardLoadingState,
  dashboardUserInfoState,
  lastActivitiesState,
  setDashboardData,
  setDashboardError,
  setDashboardLoading,
  tierState,
  toBeExpireTransactionsState,
} from 'store/dashboard/dasboardSlice';
import * as S from './services.styles';
const Services = () => {
  const { t } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { inputFields, handleChange } = useForm({
    lastActivity: {
      name: 'lastActivity',
      value: '',
      iconStart: <SearchIcon />,
      type: 'text',
      placeholder: 'Search',
    },
    miles: {
      name: 'miles',
      value: '',
      iconStart: <SearchIcon />,
      type: 'text',
      placeholder: 'Search',
    },
  });

  const userInfo = useAppSelector(dashboardUserInfoState);
  const tiers = useAppSelector(tierState);
  const lastActivities = useAppSelector(lastActivitiesState);
  const toBeExpireTransactions = useAppSelector(toBeExpireTransactionsState);
  const dashboardLoading = useAppSelector(dashboardLoadingState);

  const dispatch = useDispatch();
  useEffect(() => {
    if (!lastActivities || !toBeExpireTransactions || !userInfo || !tiers) {
      getDashboardData();
    }
  }, []);

  const getDashboardData = async () => {
    dispatch(setDashboardLoading());
    getDashboardService()
      .then((res) => {
        dispatch(setDashboardData(res.data));
      })
      .catch((ex) => {
        dispatch(setDashboardError(ex));
      });
  };

  const services = [
    {
      to: Paths.Services.transfer().route,
      title: t('pages.dashboard.sections.sidebar.cards.transferMiles.title'),
      text: t('pages.dashboard.sections.sidebar.cards.transferMiles.text'),
    },

    // {
    //   to: Paths.Services.awardTicket().route,
    //   title: t('pages.dashboard.sections.sidebar.cards.freeFlight.title'),
    //   text: t('pages.dashboard.sections.sidebar.cards.freeFlight.text'),
    // },
    {
      to: Paths.Services.convertMilages().route,
      title: t('pages.dashboard.sections.sidebar.cards.convertMilage.title'),
      text: t('pages.dashboard.sections.sidebar.cards.convertMilage.text'),
    },
    {
      to: Paths.Services.discount().route,
      title: t('pages.dashboard.sections.sidebar.cards.discount.title'),
      text: t('pages.dashboard.sections.sidebar.cards.discount.text'),
    },
    {
      to: Paths.Services.products().route,
      title: t('pages.dashboard.sections.sidebar.cards.products.title'),
      text: t('pages.dashboard.sections.sidebar.cards.products.text'),
    },
  ];

  return (
    <WithSidebar>
      <S.Wrapper>
        {dashboardLoading ? (
          <Loading />
        ) : (
          <>
            <BoxWrapper>
              <S.RowTable as={Row}>
                <S.RowItemTable as={RowItem}></S.RowItemTable>
                <S.Exchange as={RowItem} width={300}>
                  <S.Services as={Col} align="stretch">
                    <S.CardService as={Card}>
                      <S.Services as={Col} align="stretch">
                        <S.CardHead>
                          <Title>{t('pages.dashboard.sections.sidebar.title')}</Title>
                        </S.CardHead>
                        {services.map((item, index) => {
                          return (
                            <S.MenuItem key={index + item.to}>
                              <Link to={item.to}>
                                <Title>{item.title}</Title>
                              </Link>
                              <div>
                                <Text size="small">{item.text}</Text>
                              </div>
                            </S.MenuItem>
                          );
                        })}
                      </S.Services>
                    </S.CardService>
                  </S.Services>
                </S.Exchange>
              </S.RowTable>
            </BoxWrapper>
          </>
        )}
      </S.Wrapper>
    </WithSidebar>
  );
};

export default Services;
